import * as amplitude from "@amplitude/analytics-react-native"
import { elide } from "@common/utils/activationSuiteDisplay"
import { mainAccountTokenData } from "@data/auth/loginSuccess"

export const RECOGNITION_OUTCOMES = {
    EXISTING_CHILD: "recognized_existing_child",
    NEW_SIBLING: "recognized_new_sibling",
    NOT_RECOGNIZED: "not_recognized",
    SKIPPED: "recognition_skipped",
}

// Backend `recognition_outcome` → the event's outcome.
const OUTCOME_BY_LANDING = {
    known_child: RECOGNITION_OUTCOMES.EXISTING_CHILD,
    new_child: RECOGNITION_OUTCOMES.NEW_SIBLING,
    skipped: RECOGNITION_OUTCOMES.SKIPPED,
}

/**
 * One event per fast-track entry, saying how « On vous connaît déjà » ended —
 * it is how the duplicates the fast-track no longer creates are measured.
 */
export const trackRecognition = (outcome, leadIntent) => {
    amplitude.track("fast_track_recognition", {
        outcome,
        lead_intent: leadIntent,
    })
}

export const outcomeOfLanding = (landing) =>
    OUTCOME_BY_LANDING[landing?.recognition_outcome] ?? null

/**
 * The stored-token entry of one of the accounts a login opened, in the shape
 * `switchAccount` expects — null when the login holds no token for it.
 */
export const tokenDataFor = (login, userId) => {
    if (login?.user?.id === userId) return mainAccountTokenData(login)

    const entry = login?.family_tokens?.find((t) => t.user?.id === userId)
    return entry
        ? mainAccountTokenData({
              token: entry.token,
              user: {
                  ...entry.user,
                  display_name:
                      `${entry.user.firstname} ${entry.user.lastname ?? ""}`.trim(),
              },
          })
        : null
}

export const channelLabel = ({ channel, masked }) =>
    channel === "sms" ? `par SMS au ${masked}` : `par email à ${masked}`

// Every « de [Prénom] » of the flow elides (« d'Inès »): `elide` is the app's
// single rule for it.
const childName = (firstname) => firstname || "votre enfant"

/** The request the form made, first thing the family reads. */
export const recognitionRequest = (productLabel, firstname) =>
    `${productLabel ?? "Votre demande"} pour ${childName(firstname)}`

export const otherChannelLead = (firstname, channel) =>
    `Le compte ${elide(childName(firstname))} s'ouvre avec un code ${channel}.`

export const childSpaceLabel = (firstname) =>
    `Aller sur l'espace ${elide(childName(firstname))}`
